export interface DeviceConfig4Message {
  locationNamePart1: string
}

export function decodeDeviceConfig4(data: Uint8Array): DeviceConfig4Message {
  const locationNamePart1 = new TextDecoder().decode(data).split('\u0000')[0]

  return {
    locationNamePart1,
  }
}
